import React from 'react';
import AddNotePage from './AddNotePage';
import qs from 'qs';
import { connect } from 'react-redux';
import { dashboardActions } from '../../../../actions/dashboard.action';
import helper from '../../../../utils/helper';

class AddNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      errors: [],
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {
      errors: prevState.errors,
    };
    if (nextProps.dashboard.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.dashboard.isSubmitting;
    }
    if (!prevState.errors.includes(nextProps.dashboard.addNoteError)) {
      state.errors.push(nextProps.dashboard.addNoteError);
    }
    return Object.keys(state).length ? state : null;
  }
  onAddNote = (values) => {
    // const { sensorId } = this.props.match.params;
    const sensorsArr = qs
      .parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      })
      .sensorIds.split(',');
    sensorsArr.forEach((sensorId, index) => {
      this.props
        .addNote({ sensorId, ...values }, index + 1 === sensorsArr.length)
        .then((isDone) => {
          if (isDone) {
            this.props.history.goBack();
          }
        });
    });
  };
  render() {
    const { isSubmitting, errors } = this.state;
    const { sensorIds, sensorName } = helper.parseQueryString(
      this.props.location.search,
    );
    return (
      <AddNotePage
        onAddNote={this.onAddNote}
        isSubmitting={isSubmitting}
        errors={errors.filter((error) => error !== '').join('\n')}
        sensorIds={sensorIds}
        sensorName={sensorName}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.dashboard,
  };
}
export default connect(mapStateToProps, dashboardActions)(AddNote);
